/** CRUD con request methods standard per API
*/
import { getConfig } from '@shared/config/runtime.js';

import axios from "axios"

/** Mockup: se USE_MOCKUP è true, le chiamate GET che matchano un endpoint
 * nella mappa mockupMap restituiscono il JSON locale invece di chiamare il server.
 * Mettere a false per usare le API reali.
 */
const USE_MOCKUP = typeof process !== 'undefined' && process.env && process.env.USE_MOCKUP === 'true';

const mockupMap = [
    { endpoint: 'attivita.php', params: ['tutti'], loader: () => import('@src/mockup/attivita.json') },
    { endpoint: 'calendario.php', params: ['v3'], loader: () => import('@src/mockup/calendario.json') },
];

function getMockup(url) {
    if (!USE_MOCKUP) return null;
    const match = mockupMap.find(m =>
        url.includes(m.endpoint) && m.params.every(p => url.includes(p))
    );
    return match ? match.loader : null;
}

export const _api = function (url, method, data = null, auth_token = null) {
    const mockLoader = (method === 'get' || method === 'GET') ? getMockup(url) : null;
    if (mockLoader) {
        return mockLoader().then(m => m.default);
    }

    return new Promise((resolve)=>{
        let config = {
            url: url,
            method: method,
            withCredentials: true,
        }
        if (auth_token) {
            config.headers = {
                Authorization: `Bearer ${auth_token}`
            };
        }
        if (data) {
            config.data = data;
        }
        axios(config).then(
            (response)=>{
                let result = response.data;
                resolve(result);
            })
            .catch((error)=>{
                // Le API v2 rispondono agli errori con status 4xx e il corpo standard
                // ({success, message, ...}): lo passiamo al chiamante per mostrare il messaggio.
                const body = error.response && error.response.data;
                if (body && typeof body === 'object' && 'success' in body) {
                    resolve(body);
                    return;
                }
                resolve({
                    success: false,
                    data: null,
                });
            })
    });
};


/** Converte un object in parametri URI
 * @param {Object} data parametri query get
 * @return {String}
 */
export const URLparams = function (data)
{
    // let params = Object.keys(data).map(function(k) {
    //   return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
    // }).join('&');
    const URLparams = new URLSearchParams(Object.entries(data));

    return URLparams.toString();
}

const api = {};
api.URLparams = URLparams;


/** Method GET
 * @param {String} endpoint parametri query get
 * @param {String} apiUrl optional percorso per endpoint. Default da getConfig().apiUrl.
 * apiUrl = apiUrl || getConfig().apiUrl
 * @return {Promise} status=200: resolve
 */
api.get = function (endpoint, apiUrl, auth_token = null) {
    apiUrl = apiUrl || getConfig().apiUrl
    let url = apiUrl + "/" + endpoint;
    return _api(url,'get',null,auth_token);
};


/** Method PUT
 * @param {String} endpoint parametri query get
 * @param {Object} data body part della query
 * @param {String} apiUrl optional percorso per endpoint. Default da getConfig().apiUrl.
 * apiUrl = apiUrl || getConfig().apiUrl
 * @return {Promise} status=200: resolve
 */
api.put = function (endpoint, data, apiUrl, auth_token = null) {
    apiUrl = apiUrl || getConfig().apiUrl
    let url = apiUrl + "/" + endpoint;
    return _api(url,'put',data,auth_token);
};

/** Method POST
 * @param {String} endpoint parametri query get
 * @param {Object} data body part della query
 * @param {String} apiUrl optional percorso per endpoint. Default da getConfig().apiUrl.
 * apiUrl = apiUrl || getConfig().apiUrl
 * @return {Promise} status=201: resolve (aggiunto record)
 */
api.post = function (endpoint, data, apiUrl, auth_token = null) {
    apiUrl = apiUrl || getConfig().apiUrl
    let url = apiUrl + "/" + endpoint;
    return _api(url,'post',data,auth_token);
};

/** Method PUT
 * @param {String} endpoint parametri query get
 * @param {String} apiUrl optional percorso per endpoint. Default da getConfig().apiUrl.
 * apiUrl = apiUrl || getConfig().apiUrl
 * @return {Promise} status=200: resolve (eliminato)
 */
api.delete = function (endpoint, apiUrl, auth_token = null) {
    apiUrl = apiUrl || getConfig().apiUrl
    let url = apiUrl + "/" + endpoint;
    return _api(url,'delete',null,auth_token);
};


export { api as default };
